"use strict";
/* globals module */
/**
 * @module calendarEventTypeClient
 * @description  CalendarEventType Client provides an easy way to consume CalendarEventType REST API end-points. In order to obtain needed routes `calendarEventTypeClient` uses `calendarEventTypeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarEventTypeClient = /** @class */ (function () {
    function CalendarEventTypeClient(calendarEventTypeBatchClient, calendarEventTypeRoute, apiClient) {
        this.calendarEventTypeBatchClient = calendarEventTypeBatchClient;
        this.calendarEventTypeRoute = calendarEventTypeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventTypeClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventTypeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventTypeClient.prototype, "batch", {
        get: function () {
            return this.calendarEventTypeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventType resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventTypeClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventType resource.
     * @method
     * @param id CalendarEventType id which uniquely identifies CalendarEventType resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventTypeClient.get(id)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventType action has been performed. This action creates a new CalendarEventType resource.
     * @method
     * @param data A CalendarEventType object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventType action has been performed.
     * @example calendarEventTypeClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventType action has been performed. This action updates a CalendarEventType resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventType);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventType object used to update specified CalendarEventType resource.
     * @returns A promise that is resolved once the update CalendarEventType action has been performed.
     * @example calendarEventType is a resource previously fetched using get action.
                calendarEventType.name = '<name>';
                calendarEventTypeClient.update(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventType resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventType);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventType object used to delete specified CalendarEventType resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventType is a resource previously fetched using get action.
                calendarEventTypeClient.remove(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventType resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventTypeClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventTypeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventTypeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventTypeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventTypeBatchClient !== "undefined" && __1.CalendarEventTypeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventTypeRoute !== "undefined" && __1.CalendarEventTypeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventTypeClient);
    return CalendarEventTypeClient;
}());
exports.CalendarEventTypeClient = CalendarEventTypeClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
